import { createBrowserHistory } from "history";

class TransitionConfirmation {
  static handler = null;

  static suppressed = false;

  // detached when handed to createBrowserHistory, so it cannot use `this`
  static ask(message, callback) {
    const { handler, suppressed } = TransitionConfirmation;
    if (handler && !suppressed) {
      handler(callback);
      return;
    }
    callback(true);
  }
}

export function registerTransitionConfirmation(handler) {
  TransitionConfirmation.handler = handler;
  return () => {
    if (TransitionConfirmation.handler === handler) {
      TransitionConfirmation.handler = null;
    }
  };
}

export function withoutTransitionConfirmation(navigate) {
  const wasSuppressed = TransitionConfirmation.suppressed;
  TransitionConfirmation.suppressed = true;
  try {
    navigate();
  } finally {
    TransitionConfirmation.suppressed = wasSuppressed;
  }
}

export default createBrowserHistory({
  getUserConfirmation: TransitionConfirmation.ask,
});
